import { Component, Input, OnInit } from '@angular/core';
import { LostFoundModuleRestApiService } from '../../../services/lost-found-rest-api.service';
import { SettingsService } from '@core/services/settings/settings.service';

@Component({
  selector: 'logs-tab',
  templateUrl: './logs-tab.component.html',
  styleUrls: ['./logs-tab.component.less']
})
export class LogsTabComponent implements OnInit {
  @Input() statementId: string;
  logs: Array<{dt: Date, id: number, text: string}> = [];

  constructor(
    public restApi: LostFoundModuleRestApiService,
    private settingsService: SettingsService,
  ) { }

  ngOnInit(): void {
    this.loadLogs();
    this.readLogs();
  }

  async loadLogs() {
    const xRequestId = this.settingsService.general.randomUuid;
    const data = await this.restApi.getLogs(this.statementId, xRequestId);
    this.logs = data;
  }

  async readLogs() {
    const xRequestId = this.settingsService.general.randomUuid;
    await this.restApi.readLogs(this.statementId, xRequestId);
  }

}
